<template>
  <div class="contact">
    <article class="message mv1">
      <div class="message-body">
        <a :href="phone()">{{ practice.phone }}</a>
      </div>
    </article>

    <article class="message mv1">
      <div class="message-body">
        <a :href="url()" target="_blank">{{ practice.websiteUrl }}</a>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: "contact",

  computed: {
    practice() {
      return this.$store.state.practice;
    }
  },

  methods: {
    phone() {
      return `tel:${this.$store.state.practice.phone}`;
    },
    url() {
      return this.$store.state.practice.websiteUrl;
    }
  }
};
</script>

<style lang="scss" scoped></style>
